module.exports = __webpack_public_path__ + "static/media/comic-carton-01.a4b33e88.png";